"use client";

import { useClientHasNetwork } from "@easybiz/component-shared";
import React from "react";
import { FormattedMessage } from "react-intl";

function useOfflineAlert() {
  const online = useClientHasNetwork();

  if (online === false) {
    return {
      title: (
        <FormattedMessage
          id="no.internet.connection"
          defaultMessage="<b>No Internet Connection</b>, Try 1. Reconnecting to Wi-Fi. 2. Checking the network cables, modem and router"
          values={{ b: (t) => <b>{t}</b> }}
        />
      ),
      reloadBtn: <FormattedMessage id="reload.app" defaultMessage="Reload App" />,
    };
  }
}

export default useOfflineAlert;
